import { Fragment } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";

interface NavItem {
  to: string;
  label: string;
  permission?: string;
  section: string;
}

const NAV: NavItem[] = [
  { to: "/", label: "Painel", section: "Monitoramento" },
  { to: "/devices", label: "Dispositivos", permission: "devices.read", section: "Monitoramento" },
  { to: "/requests", label: "Requisicoes", permission: "devices.read", section: "Monitoramento" },
  { to: "/groups", label: "Grupos e politicas", permission: "groups.read", section: "Configuracao" },
  { to: "/users", label: "Usuarios e papeis", permission: "users.manage", section: "Configuracao" },
];

export function Layout() {
  const { user, logout, can } = useAuth();
  const navigate = useNavigate();

  const visible = NAV.filter((item) => !item.permission || can(item.permission));
  let lastSection = "";

  function handleLogout() {
    logout();
    navigate("/login");
  }

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="brand">
          <span className="brand-mark">SE</span>
          Secure Endpoint
        </div>
        <nav className="nav">
          {visible.map((item) => {
            const header =
              item.section !== lastSection ? (
                <span key={item.section} className="nav-section">
                  {item.section}
                </span>
              ) : null;
            lastSection = item.section;
            return (
              <Fragment key={item.to}>
                {header}
                <NavLink to={item.to} end={item.to === "/"} className={({ isActive }) => (isActive ? "active" : "")}>
                  {item.label}
                </NavLink>
              </Fragment>
            );
          })}
        </nav>
        <div className="sidebar-foot">
          <div className="who">{user?.name}</div>
          <div>
            {user?.email} · {user?.role}
          </div>
          <div style={{ marginTop: 10 }}>
            <button className="btn sm" onClick={handleLogout} style={{ width: "100%" }}>
              Sair
            </button>
          </div>
        </div>
      </aside>
      <div className="main">
        <header className="topbar">
          <strong>Console de gestao de dispositivos</strong>
          <span className="muted">Ambiente de demonstracao — dados sinteticos</span>
          <span className="spacer" />
          <span className="badge">
            <span className="dot" />
            {user?.role}
          </span>
        </header>
        <Outlet />
      </div>
    </div>
  );
}
